// Shared organization activity feed (Dashboard + Updates tabs).
import type { CSSProperties } from 'react';
import type { OrgUpdate } from '@/types';
import { formatDateTime } from '@/lib/datetime';
import { feedByline, feedKeyLabels, feedMark } from './orgUpdatesFeedMeta';

export interface OrgUpdatesFeedProps {
  rows: OrgUpdate[];
  emptyMessage?: string;
}

export default function OrgUpdatesFeed({
  rows,
  emptyMessage = 'No updates yet.',
}: OrgUpdatesFeedProps) {
  if (rows.length === 0) {
    return (
      <p className="org-feed-empty" role="status">
        {emptyMessage}
      </p>
    );
  }

  return (
    <ul className="org-feed">
      {rows.map((row, index) => {
        const byline = feedByline(row);
        const keys = feedKeyLabels(row.updatedKeys);
        const mark = feedMark(row.updateType);
        return (
          <li key={`${row.createdAt}-${row.updateType}-${index}`} className="org-feed-item">
            <span
              className="org-feed-mark"
              style={
                { '--org-feed-fg': mark.color, '--org-feed-mix': mark.mix } as CSSProperties
              }
              aria-hidden="true"
            >
              <i className={`bi ${mark.icon}`} />
            </span>
            <div className="org-feed-body">
              <p className="org-feed-summary">{row.summary || row.updateType}</p>
              {byline || keys ? (
                <p className="org-feed-detail">
                  {byline}
                  {byline && keys ? ' · ' : null}
                  {keys ? `Key: ${keys}` : null}
                </p>
              ) : null}
            </div>
            <time className="org-feed-time" dateTime={row.createdAt}>
              {formatDateTime(row.createdAt)}
            </time>
          </li>
        );
      })}
    </ul>
  );
}
